import React from 'react';
import { useAuth } from '../contexts/Auth';
import { useTranslation } from 'react-i18next';

export default function Settings() {
  const { user } = useAuth();
  const { t } = useTranslation();

  return (
    <div className="container flex px-4 py-4">
      <p className="mx-auto">
        <span className="font-medium">{t('label.email')}: </span>{user.email}
      </p>
    </div>
  );
}
